import { config } from 'config/constants';

interface SodaOriginOptions {
  origins: Array<string | undefined>;
  previewHostSuffix?: string;
}

// Previews de Amplify del front Soda: `pr-<n>.<appId>.amplifyapp.com` (CB-183).
const PREVIEW_HOST_PREFIX = /^pr-\d+$/;

const toOrigin = (url: string): string => {
  try {
    return new URL(url).origin;
  } catch {
    return '';
  }
};

const isPreviewUrl = (url: URL, hostSuffix?: string): boolean => {
  if (!hostSuffix?.startsWith('.')) return false;
  if (url.protocol !== 'https:' || url.port !== '') return false;
  const host = url.hostname.toLowerCase();
  const suffix = hostSuffix.toLowerCase();
  if (!host.endsWith(suffix)) return false;
  return PREVIEW_HOST_PREFIX.test(host.slice(0, -suffix.length));
};

/**
 * ¿La URL pertenece a un origen de confianza de Soda? Exacto contra los orígenes
 * configurados y, solo si viene `previewHostSuffix` (únicamente en STG), también
 * los previews de Amplify del front Soda.
 */
export function isTrustedSodaUrl(url: string, options: SodaOriginOptions): boolean {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  const allowedOrigins = options.origins
    .filter((u): u is string => Boolean(u))
    .map(toOrigin)
    .filter(Boolean);
  if (allowedOrigins.includes(parsed.origin)) return true;
  return isPreviewUrl(parsed, options.previewHostSuffix);
}

export const isSodaOrigin = (url: string): boolean =>
  isTrustedSodaUrl(url, {
    origins: [config.soda.sodaUrl, config.soda.sodaVercelUrl],
    previewHostSuffix: config.soda.sodaPreviewHostSuffix,
  });
